import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchConfigRevisableValues = () => {
	return fetch(apiBasename + '/configRevisableValue', authorization())
	.then(checkStatus)
	.then((res) => res.json());
};
